export default __webpack_public_path__ + "./image/47e23208532e015485a8ea9d33366d93.png";